import styled from 'styled-components';

const commonScreenStyle = `
  font-size: 1.5em;
  text-align: center;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;`;

export const StyledTitle = styled.h1`
  ${commonScreenStyle}
  padding: 1em 0 0;
  font-weight: bold;
  font-size: 23px;
  background-color: #fff;
  color: black;

  @media (max-width: 768px) {
    font-size: 20px;
    padding: 1em 0.75em;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    padding: 2em 0.5em 0;
  }
`;

export const StyledSubtitle = styled.h2`
  ${commonScreenStyle}
  color: #EF0000;

  @media (max-width: 768px) {
    font-size: 1.3em;
    padding: 0.5em 0;
  }

  @media (max-width: 480px) {
    font-size: 1.1em;
    padding: 0.5em 0;
  }
`;

export const StyledText = styled.div`
  text-align: center;
  line-height: 1.6;
  font-size: 1em;
  padding: 1.5em 1em;
  margin: 1em auto;
  max-width: 600px;
  color: #333;

  @media (max-width: 768px) {
    font-size: 0.95em;
    padding: 1em 0.75em;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    font-size: 0.9em;
    padding: 0.75em 0.5em;
    line-height: 1.5;
  }

  a {
    color: #126cd1;
  }

  a:hover {
    color: #105cb7;
  }

  a:focus,
  a:focus-visible,
  a:focus-within {
    outline: 2px solid #111;
    outline-offset: 2px;
  }

  p {
    margin: 0;
  }
`;

export const StyledDiv = styled.div`
  margin: 24px 50px;

  @media (max-width: 768px) {
    margin: 16px 20px;
  }

  @media (max-width: 480px) {
    margin: 12px 16px;
  }
`;
